import React from 'react';

import {styled} from '@mui/system';

import ProgressSpinner from '../atoms/ProgressSpinner';


const StyledStatusInfo = styled('div')(({ theme }) =>({
    marginTop: 100,
    marginBottom: 30,
    textAlign: 'center',
    fontSize: theme.custom.font.large
}));


class ApplicationOffline extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
           <div>
               <StyledStatusInfo>
                   The application is temporarily unavailable due to maintenance work.
               </StyledStatusInfo>
               <ProgressSpinner />
            </div>
        );
    }

}

export default ApplicationOffline;
